export default __webpack_public_path__ + "static/media/tarigoppala-parvathi.d050c5bb.png";